export default {
 template: require('./wtg-user-search.html'),
 bindings: {
  limit: "@",		// search entries limit
  debounce: "@",	// debounce time in ms
  minlen: "@",		// minimum query length
  onClick: "&"		// click event handler
 },
 controller: function($scope,$rootScope,INTRACTABLE,L,$timeout) {
  var that = this;
  that.$onInit = function() {
   if(angular.isUndefined(that.limit)) that.limit = 30;
   if(angular.isUndefined(that.debounce)) that.debounce = 800;
   if(angular.isUndefined(that.minlen)) that.minlen = 3;
  };
  $scope.strings = $rootScope.strings;
  $scope.search = {query:""};

  var debouncer; // we should also make sure we're not running to many searches
  $scope.on_q_change = function() {
   if(debouncer) $timeout.cancel(debouncer);
   debouncer = $timeout(function() {
    if($scope.search.query.length<3) return ($scope.search.result=null);
    INTRACTABLE.request('user/list',{Q:$scope.search.query,L:that.limit},function(e,r) {
     if(e) return L.error({err:e},"error searching users");
     if(r._S!='ok') return L.warn({r:r},"error searching users");
     $scope.search.results = r.users;
    });
   },that.debounce);
  };

 }
};
/* vim:set ts=8 sw=1 expandtab: */
